import React, { useEffect, useState, useRef } from "react";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Input,
  Textarea,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";
import { handleSendNotification } from "actions/actions";
import { toast } from "react-toastify";
import { IoIosSearch } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";

const SendNotification = ({ selectedIds }) => {
  const [formData, setFormData] = useState({
    title: "",
    body: "",
  });
  const closeRef = useRef();
  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("name");
  const location = useLocation();
  const navigate = useNavigate();

  const handleSend = async () => {
    if (!formData.title || !formData.body) {
      return toast.error("الرجاء ملء جميع الحقول");
    } else if (selectedIds.length === 0) {
      return toast.error("الرجاء تحديد مستخدم واحد على الأقل");
    }

    const body = {
      title: formData.title,
      body: formData.body,
      userIds: selectedIds,
    };

    const res = await handleSendNotification(body);

    if (res.error) {
      return toast.error(res.error);
    }

    toast.success(res.success);
    setFormData({ title: "", body: "" });
    closeRef.current?.click();
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const searchParam = params.get(searchBy);
    setSearch(searchParam || "");
  }, [location.search, searchBy]);

  const handleSearch = (e) => {
    const params = new URLSearchParams(location.search);
    if (e.target.value === "") {
      params.delete(searchBy);
      params.delete("page");
      navigate(`${location.pathname}?${params.toString()}`);
      return;
    }
    params.set(searchBy, e.target.value);
    params.delete("page");
    navigate(`${location.pathname}?${params.toString()}`);
  };

  const handleChangeSearchBy = (e) => {
    setSearchBy(e.target.value);
    const params = new URLSearchParams(location.search);
    params.delete(searchBy);
    params.delete("page");
    navigate(`${location.pathname}?${params.toString()}`);
  };

  return (
    <div className="flex items-center gap-4">
      <div className="relative flex items-center gap-2 rounded-lg border border-gray-200 bg-gray-100 px-4 py-2 dark:border-navy-700 dark:bg-navy-800">
        <select
          onChange={handleChangeSearchBy}
          className="w-fit bg-gray-100 focus:outline-none dark:bg-navy-800"
        >
          <option value="name">الاسم</option>
          <option value="phoneNumber">الهاتف</option>
        </select>
        <input
          className="w-full bg-gray-100 focus:outline-none dark:bg-navy-800"
          type="search"
          placeholder="ابحث..."
          value={search}
          onChange={handleSearch}
        />
        <IoIosSearch size={30} />
      </div>
      <DialogRoot dir="rtl">
        <DialogTrigger asChild>
          <button
            className="my-4 rounded-md bg-blueSecondary py-2 px-4 text-white transition-all float-end hover:bg-brandLinear"
            variant="outline"
            size="sm"
          >
            إرسال إشعار
          </button>
        </DialogTrigger>
        <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
          <DialogHeader>
            <DialogTitle className="text-xl font-bold">إرسال اشعار</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <div className="mb-4">
              <label className="mb-2 block text-base" htmlFor="title">
                العنوان
              </label>
              <Input
                className="w-full border p-2"
                placeholder="الرجاء كتابة العنوان"
                id="title"
                value={formData.title}
                onChange={(e) =>
                  setFormData({ ...formData, title: e.target.value })
                }
              />
            </div>
            <div className="mb-4">
              <label className="mb-2 block text-base" htmlFor="body">
                الرسالة
              </label>
              <Textarea
                className="h-32 w-full resize-none border p-2"
                placeholder="الرجاء كتابة الرسالة"
                id="body"
                value={formData.body}
                onChange={(e) =>
                  setFormData({ ...formData, body: e.target.value })
                }
              />
            </div>
          </DialogBody>
          <DialogFooter>
            <Button onClick={handleSend} variant="outline">
              <span>إرسال</span>
            </Button>
            <DialogActionTrigger asChild ref={closeRef}>
              <Button variant="outline">
                <span>إلغاء</span>
              </Button>
            </DialogActionTrigger>
          </DialogFooter>
          <DialogCloseTrigger />
        </DialogContent>
      </DialogRoot>
    </div>
  );
};

export default SendNotification;
